/** Возможные состояния маркера */
export enum MarkerStates {
    Inactive,
    Unlinked,
    Linked,
}
